const CARRIER_EXPORT_KEY = 'carrier_search_export_v1';

const normalizeRows = (payload) => {
  if (!payload) return [];
  if (payload.searchType === 'batch') return payload.batchResults || [];
  return Array.isArray(payload) ? payload : [payload];
};

const headers = [
  'Legal Name',
  'DBA',
  'DOT',
  'MC',
  'Primary Contact',
  'Secondary Contact',
  'Phone',
  'Cell Phone',
  'Fax',
  'Email',
  'State(Physical)',
  'State(Mailing)',
  'Physical Address',
  'Mailing Address',
  'Status',
  'Carrier Operation',
  'Entity Type',
  'Entity Classification',
  'Business Organization',
  'Cargo Classification',
  'Power Units',
  'Drivers',
  'Total CDL Drivers',
  'Owned Trucks',
  'Owned Tractors',
  'Owned Trailers',
  'Leased Trucks',
  'Leased Tractors',
  'Leased Trailers',
  'MCS-150 Date',
  'Add Date',
  'MCS-150 Mileage',
  'MCS-150 Mileage Year',
  'Active Duration',
  'Authority Common',
  'Authority Broker',
  'Authority Pending Common',
  'Authority Pending Contract',
  'Authority Pending Broker',
  'Authority Revocation Common',
  'Authority Revocation Contract',
  'Authority Revocation Broker',
  'Insurance Type',
  'Insurance Class',
  'Insurance Max Coverage',
  'Insurance Underlying Limit',
  'Insurance Policy Number',
  'Insurance Effective Date',
  'Insurance Form Code',
  'Insurance Company',
  'Pending Insurance Form Code',
  'Pending Insurance Type',
  'Pending Insurance Company',
  'Pending Insurance Policy',
  'Pending Insurance Posted Date',
  'Pending Insurance Underlying Limit',
  'Pending Insurance Max Coverage',
  'Pending Insurance Effective Date',
  'Pending Insurance Cancel Date',
  'Authority History Action',
  'Authority History Service Type',
  'Authority History Served Date',
  'Revocation Pending',
  'Alerts',
];

export const carrierTemplateSampleRows = [
  {
    'Legal Name': 'ALPHA ENVIRONMENTAL',
    'DBA': 'AST INDUSTRIAL & ENVIRONMENTAL',
    'DOT': '297002',
    'MC': '408185',
    'Primary Contact': '',
    'Secondary Contact': '',
    'Phone': '5024581899',
    'Cell Phone': '',
    'Fax': '',
    'Email': 'stacyfroman@astl.com',
    'State(Physical)': 'KY',
    'State(Mailing)': 'KY',
    'Physical Address': '4511 ILLINOIS AVE, LOUISVILLE, KY 40213-1920',
    'Mailing Address': '4511 ILLINOIS AVE, LOUISVILLE, KY 40213-1920',
    'Status': 'Inactive',
    'Carrier Operation': 'Interstate',
    'Entity Type': 'Carrier',
    'Entity Classification': 'AUTHORIZED FOR HIRE',
    'Business Organization': 'Corporation',
    'Cargo Classification': '',
    'Power Units': '13',
    'Drivers': '13',
    'Total CDL Drivers': '13',
    'Owned Trucks': '4',
    'Owned Tractors': '7',
    'Owned Trailers': '6',
    'Leased Trucks': '',
    'Leased Tractors': '',
    'Leased Trailers': '',
    'MCS-150 Date': '2003-01-09',
    'Add Date': '1987-07-08',
    'MCS-150 Mileage': '585000',
    'MCS-150 Mileage Year': '2002',
    'Active Duration': '',
  },
  {
    'Legal Name': 'FALL RIVER RENTAL CO INC',
    'DBA': '',
    'DOT': '297011',
    'MC': '',
    'Primary Contact': 'MARINA SILVA',
    'Secondary Contact': '',
    'Phone': '5086742000',
    'Cell Phone': '5086742000',
    'Fax': '',
    'Email': 'centurypave96@comcast.net',
    'State(Physical)': 'MA',
    'State(Mailing)': 'MA',
    'Physical Address': '42 N QUARRY ST, FALL RIVER, MA 02723-1448',
    'Mailing Address': '42 N QUARRY ST, FALL RIVER, MA 02723-1448',
    'Status': 'Active',
    'Carrier Operation': 'Interstate',
    'Entity Type': 'Carrier',
    'Entity Classification': 'PRIVATE PROPERTY',
    'Business Organization': 'Corporation',
    'Cargo Classification': '',
    'Power Units': '1',
    'Drivers': '1',
    'Total CDL Drivers': '1',
    'Owned Trucks': '1',
    'Owned Tractors': '',
    'Owned Trailers': '',
    'Leased Trucks': '',
    'Leased Tractors': '',
    'Leased Trailers': '',
    'MCS-150 Date': '2025-04-22',
    'Add Date': '1987-07-08',
    'MCS-150 Mileage': '50',
    'MCS-150 Mileage Year': '2024',
    'Active Duration': '',
  },
  {
    'Legal Name': 'BMCO INDUSTRIES INC',
    'DBA': '',
    'DOT': '297020',
    'MC': '',
    'Primary Contact': 'BRUNO PIRONIO',
    'Secondary Contact': 'SUSAN PIERSON',
    'Phone': '4017816884',
    'Cell Phone': '',
    'Fax': '',
    'Email': 'sales@bmcoindustries.com',
    'State(Physical)': 'RI',
    'State(Mailing)': 'RI',
    'Physical Address': '159 FRANCES AVE, CRANSTON, RI 02910-2211',
    'Mailing Address': '159 FRANCES AVE, CRANSTON, RI 02910-2211',
    'Status': 'Inactive',
    'Carrier Operation': 'Interstate',
    'Entity Type': 'Carrier',
    'Entity Classification': 'PRIVATE PROPERTY',
    'Business Organization': 'Corporation',
    'Cargo Classification': '',
    'Power Units': '1',
    'Drivers': '2',
    'Total CDL Drivers': '1',
    'Owned Trucks': '1',
    'Owned Tractors': '',
    'Owned Trailers': '',
    'Leased Trucks': '',
    'Leased Tractors': '',
    'Leased Trailers': '',
    'MCS-150 Date': '2009-01-19',
    'Add Date': '1987-07-08',
    'MCS-150 Mileage': '300',
    'MCS-150 Mileage Year': '2008',
    'Active Duration': '',
  },
].map((row) => headers.reduce((acc, key) => {
  acc[key] = row[key] || '';
  return acc;
}, {}));

export const saveCarrierExport = (payload) => {
  const rows = normalizeRows(payload);
  if (!rows.length) return null;

  const mappedRows = rows.map((c) => ({
    'Legal Name': c.legalName || '',
    'DBA': c.dbaName || '',
    'DOT': c.dotNumber || '',
    'MC': c.mcNumber || '',
    'Primary Contact': c.companyOfficer1 || '',
    'Secondary Contact': c.companyOfficer2 || '',
    'Phone': c.phone || '',
    'Cell Phone': c.cellPhone || '',
    'Fax': c.fax || '',
    'Email': c.email || '',
    'State(Physical)': c.phyState || '',
    'State(Mailing)': c.mailState || '',
    'Physical Address': c.physicalAddress || '',
    'Mailing Address': c.mailingAddress || '',
    'Status': c.status || '',
    'Carrier Operation': c.carrierOperation || '',
    'Entity Type': c.entityType || '',
    'Entity Classification': c.entityClassification || '',
    'Business Organization': c.businessOrganization || '',
    'Cargo Classification': c.cargoClassification || '',
    'Power Units': c.powerUnits || '',
    'Drivers': c.totalDrivers || '',
    'Total CDL Drivers': c.totalCDLDrivers || '',
    'Owned Trucks': c.ownTrucks || '',
    'Owned Tractors': c.ownTractors || '',
    'Owned Trailers': c.ownTrailers || '',
    'Leased Trucks': c.termLeasedTrucks || '',
    'Leased Tractors': c.termLeasedTractors || '',
    'Leased Trailers': c.termLeasedTrailers || '',
    'MCS-150 Date': c.mcs150Date || '',
    'Add Date': c.addDate || '',
    'MCS-150 Mileage': c.mcs150Mileage || '',
    'MCS-150 Mileage Year': c.mcs150MileageYear || '',
    'Active Duration': c.activeDuration || '',
    'Authority Common': c.authorityInfo?.commonAuthority || '',
    'Authority Broker': c.authorityInfo?.brokerAuthority || '',
    'Authority Pending Common': c.authorityInfo?.pendingCommon ? 'Yes' : '',
    'Authority Pending Contract': c.authorityInfo?.pendingContract ? 'Yes' : '',
    'Authority Pending Broker': c.authorityInfo?.pendingBroker ? 'Yes' : '',
    'Authority Revocation Common': c.authorityInfo?.revocationCommon ? 'Yes' : '',
    'Authority Revocation Contract': c.authorityInfo?.revocationContract ? 'Yes' : '',
    'Authority Revocation Broker': c.authorityInfo?.revocationBroker ? 'Yes' : '',
    'Insurance Type': c.insuranceInfo?.type || '',
    'Insurance Class': c.insuranceInfo?.class || '',
    'Insurance Max Coverage': c.insuranceInfo?.maxCoverage || '',
    'Insurance Underlying Limit': c.insuranceInfo?.underlyingLimit || '',
    'Insurance Policy Number': c.insuranceInfo?.policyNumber || '',
    'Insurance Effective Date': c.insuranceInfo?.effectiveDate || '',
    'Insurance Form Code': c.insuranceInfo?.formCode || '',
    'Insurance Company': c.insuranceInfo?.companyName || '',
    'Pending Insurance Form Code': c.pendingInsurance?.formCode || '',
    'Pending Insurance Type': c.pendingInsurance?.typeDescription || '',
    'Pending Insurance Company': c.pendingInsurance?.companyName || '',
    'Pending Insurance Policy': c.pendingInsurance?.policyNumber || '',
    'Pending Insurance Posted Date': c.pendingInsurance?.postedDate || '',
    'Pending Insurance Underlying Limit': c.pendingInsurance?.underlyingLimit || '',
    'Pending Insurance Max Coverage': c.pendingInsurance?.maxCoverage || '',
    'Pending Insurance Effective Date': c.pendingInsurance?.effectiveDate || '',
    'Pending Insurance Cancel Date': c.pendingInsurance?.cancelEffectiveDate || '',
    'Authority History Action': c.authorityHistory?.action || '',
    'Authority History Service Type': c.authorityHistory?.serviceType || '',
    'Authority History Served Date': c.authorityHistory?.servedDate || '',
    'Revocation Pending': c.revocationInfo?.hasRevocation ? 'Yes' : '',
    'Alerts': Array.isArray(c.alerts) ? c.alerts.join('; ') : '',
  }));

  const record = {
    headers,
    rows: mappedRows,
    count: mappedRows.length,
    createdAt: new Date().toISOString(),
  };

  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(CARRIER_EXPORT_KEY, JSON.stringify(record));
    } catch {
      // ignore storage errors
    }
  }

  return record;
};

const escapeCsv = (value) => {
  const s = value === undefined || value === null ? '' : String(value);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const buildCarrierTemplateCsv = (rows = []) => {
  const normalizedRows = Array.isArray(rows) ? rows : [];
  const lines = [headers.join(',')];
  normalizedRows.forEach((row) => {
    const line = headers.map((key) => escapeCsv(row?.[key] || '')).join(',');
    lines.push(line);
  });
  return `${lines.join('\n')}\n`;
};

export const downloadCarrierTemplateCsv = (options = {}) => {
  const {
    filename = 'carrier_recipients_template.csv',
    rows = [],
  } = options;
  const blob = new Blob([buildCarrierTemplateCsv(rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const downloadCarrierCsv = (payload) => {
  const record = saveCarrierExport(payload);
  if (!record || !record.rows?.length) return null;
  const lines = [record.headers.join(',')];
  record.rows.forEach((row) => {
    const line = record.headers.map((key) => escapeCsv(row[key])).join(',');
    lines.push(line);
  });
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
  a.href = url;
  a.download = `carriers-${ts}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return record;
};

export const loadCarrierExport = () => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(CARRIER_EXPORT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !Array.isArray(parsed.rows)) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const carrierExportHeaders = headers;
